<template>
  <div class="flex flex-row w-full">
    <div class="flex-grow">
      {{ color.name }}

      <div v-if="hasTextColors" class="mt-2">
        <div v-for="(color, idx) in color.colors" :key="idx" :style="`background-color: rgba(${color},1)`"
          @click="changeColor(color)"
          class="w-2 h-2 p-4 rounded float-left mr-2 mb-2 border-2  hover:border-brandhelfer-green cursor-pointer"
          :class="selectedColor == color
            ? 'border-brandhelfer-green cursor-default'
            : 'border-gray-200'
            "></div>

        <span v-if="hasPicker" class="float-left mr-2 mb-2" :title="pickerTooltip">
          <button type="button" :disabled="!pickerEnabled" @click="$emit('pickerRequested', color)"
            class="w-9 h-9 p-0 rounded border-2 border-gray-200 text-gray-700 flex items-center justify-center focus:outline-none"
            :class="pickerEnabled
              ? 'hover:text-brandhelfer-green hover:border-brandhelfer-green cursor-pointer'
              : 'opacity-40 cursor-not-allowed'"
            :style="pickerButtonStyle"
            aria-label="Farbe aus Hintergrund wählen">
            <i class="fa fa-eyedropper text-xs opacity-80" aria-hidden="true"></i>
          </button>
        </span>
      </div>
    </div>
    <div class="w-1/5">
      <toggle :idx="color.id" :enabled="color.enabled" @toggled="statusToggled"></toggle>
    </div>
  </div>
</template>

<script>
import Toggle from '@/Shared/Toggle.vue';

export default {
  components: {
    Toggle,
  },

  props: {
    color: Object,
    pickerEnabled: {
      type: Boolean,
      default: true,
    },
    pickerColor: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      selectedColor: this.color.defaultColor
    };
  },

  mounted() {
    this.selectedColor = this.color?.color ?? this.color?.defaultColor ?? '';
  },

  watch: {
    'color.color': {
      handler(newVal) {
        this.selectedColor = newVal ?? this.color?.defaultColor ?? '';
      },
      immediate: true
    }
  },



  // mounted() {
  //   if(this.color.enabled !== undefined) {
  //     this.$emit('statusToggled', this.color, this.color.enabled);
  //   }
  // },


  methods: {
    changeColor(color) {
      this.selectedColor = color;

      this.$emit('colorChanged', this.color, color);
    },

    statusToggled(idx, status) {
      this.$emit('statusToggled', this.color, status);
    },
  },

  computed: {
    hasTextColors() {
      return this.color.colors.length > 1;
    },

    hasPicker() {
      return Boolean(this.color.picker);
    },

    pickerTooltip() {
      return this.pickerEnabled
        ? 'Farbe aus Hintergrund wählen'
        : 'Bitte laden Sie zuerst ein Hintergrundbild hoch.';
    },

    pickerButtonStyle() {
      if (!this.pickerColor) {
        return {};
      }

      const [red, green, blue] = this.pickerColor.split(',').map(Number);
      const brightness = (red * 299 + green * 587 + blue * 114) / 1000;

      return {
        backgroundColor: `rgba(${this.pickerColor},1)`,
        color: brightness < 150 ? '#ffffff' : '#1f2937',
      };
    },
  },
};
</script>
